import * as React from "react";

import { ErrorBoundary } from "@shared/ui/common/ErrorBoundary";
import {
  AdminOfflineBoundary,
  AdminPwaStatus,
} from "@shared/ui/common/AdminPwa";
import { OfflineDetector } from "@shared/ui/common/OfflineDetector";
import { Shell } from "@widgets/layout/Shell";
import { AuthProvider } from "@app/providers/auth";
import { I18nProvider } from "@app/providers/i18n";
import { QueryProvider } from "@app/providers/query";
import { SessionHydrator } from "@app/providers/sessionHydrator";
import { TenantProvider } from "@app/providers/tenant";
import { ToastProvider } from "@app/providers/toast";
import { AcquisitionAnalyticsProvider } from "@app/providers/acquisitionAnalytics";

export function AdminAppProviders({ children }: { children: React.ReactNode }) {
  return (
    <I18nProvider>
      <AcquisitionAnalyticsProvider>
        <AuthProvider>
          <SessionHydrator>
            <TenantProvider>
              <ToastProvider>
                <OfflineDetector />
                <ErrorBoundary>
                  <QueryProvider>
                    <AdminPwaStatus />
                    <AdminOfflineBoundary>
                      <Shell>{children}</Shell>
                    </AdminOfflineBoundary>
                  </QueryProvider>
                </ErrorBoundary>
              </ToastProvider>
            </TenantProvider>
          </SessionHydrator>
        </AuthProvider>
      </AcquisitionAnalyticsProvider>
    </I18nProvider>
  );
}
